<template>
  <v-container fluid grid-list-md class="px-0 pb-0">
    <v-row>
      <v-col cols="12">
        <div class="title-float accent--text">
          {{$tc('label.campos_gerais', 1)}}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-row>
                <v-col cols="6" v-if="!somenteLeitura || passoGeral.numeroContrato">
                  <v-text-field
                    id="numero_contrato_campos_gerais"
                    v-model="passoGeral.numeroContrato"
                    :rules="[rules.required]"
                    :disabled="somenteLeitura"
                    :label="`${$tc('label.numero_contrato', 1)} *`"/>
                </v-col>
                <v-col cols="6" v-if="!somenteLeitura || passoGeral.notaFiscal">
                  <v-text-field
                    id="numero_nota_fiscal_campos_gerais"
                    v-model="passoGeral.notaFiscal"
                    :rules="[rules.required]"
                    :disabled="somenteLeitura"
                    :label="`${$tc('label.numero_nota_fiscal', 1)} *`"/>
                </v-col>
                <v-col cols="6" v-if="!somenteLeitura || passoGeral.idClienteAcao">
                  <v-autocomplete
                    id="costumer_codigo_campos_gerais"
                    name="costumer_codigo_campos_gerais"
                    v-model="passoGeral.idClienteAcao"
                    :items="clientes"
                    item-text="costumerCliente"
                    item-value="id"
                    clearable
                    :rules="[rules.required]"
                    :disabled="somenteLeitura"
                    @click.native="buscaClientes"
                    :label="`${$tc('label.customer_cliente', 1)} *`"/>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                  v-if="this.passoGeral.descricao"
                    id="descricao_campos_gerais"
                    v-model="passoGeral.descricao"
                    :disabled="somenteLeitura"
                    :label="`${$tc('label.descricao', 1)}`"/>
                </v-col>
                <v-col cols="12"
                      v-if="justificativa">
                  <v-text-field
                    v-model="justificativa"
                    :label="`${$tc('label.justificativa', 1)}`"
                    :disabled="true"/>
                </v-col>
              </v-row>
              <metadados-container-layout
                v-if="parametrosAplicados"
                :metadados-entidade="metadadosParametrizado"
                :layout-class="layoutClass"
                :input-layout="inputLayout"
                :objeto="passoGeral"
                :campos-formulario="camposFormulario"
                :ordenacao-campos="ordenacaoFormulario"
                :explode-hierarquia="true"
                :somente-leitura="somenteLeitura"
                :exibe-loading-overlay="false"
                ref="container">
              </metadados-container-layout>
              <v-row>
                <v-col cols="12" class="py-0">
                  <span v-show="passoGeral.status === 'CANCELADO'">
                    {{ $t('message.justificativa_cancelamento_acao_data', {
                      data: formatDatePattern(passoGeral.dtaCancelamento, 'YYYY-MM-DD'),
                      hora: passoGeral.horaCancelamento,
                      usuario: passoGeral.usuarioCancelamento,
                      justificativa: passoGeral.justificativaCancelamento,
                    }) }}
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import MetadadosContainerLayout from '../../../../shared-components/metadados/MetadadosContainerLayout';
import { buscarClientes } from '../../../../../common/resources/akzo-acao-projeto';
import { formatDatePattern } from '../../../../common/functions/date-utils';

export default {
  props: {
    alterarFinalizado: Boolean,
    copia: Boolean,
    novo: Boolean,
    passoGeral: Object,
    edicao: Boolean,
    somenteLeitura: Boolean,
    configuracaoAcao: Object,
    justificativa: String,
    camposLimitadores: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('metadados', [
      'getAcaoMetadado',
      'getProdutoMetadado',
    ]),
    ordenacaoFormulario() {
      return this.delimitaCamposDeProduto();
    },
    comMeta() {
      return this.configuracaoAcao
        && this.configuracaoAcao.templateCalculo !== ''
        && this.configuracaoAcao.templateCalculo !== 'META_N/A';
    },
    valorAcaoTemplateValorTotalAcao() {
      const { configuracao } = this.configuracaoAcao;
      return configuracao.passo3.template === 'VALOR_TOTAL_ACAO';
    },
    isDetalheAcaoTemplate() {
      const { configuracao } = this.configuracaoAcao;
      return configuracao.passo3.template === 'DETALHE_ACAO';
    },
  },
  components: {
    MetadadosContainerLayout,
  },
  data() {
    return {
      produtoResource: this.$api.produto(this.$resource),

      layoutClass: { wrap: true },
      inputLayout: {
        xs12: true,
        sm6: true,
        md3: true,
      },

      parametrosAplicados: false,
      metadadosParametrizado: {},

      clientes: [],
      buscaListaClientes: null,

      camposFormulario: {
        padrao: [
          {
            labelCampo: 'valor',
            tipoCampo: 'DINHEIRO',
            vlrObrigatorio: true,
          },
          {
            labelCampo: 'produto',
            nomCampoId: 'idProduto',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => {
                const parametros = {
                  autocomplete,
                  ...this.$refs.container.getValoresDependencias(),
                };
                return this.produtoResource.selecao(parametros);
              },
              itemValue: 'id',
              itemText: 'nomProduto',
            },
          },
        ],
      },

      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredFunction: (objLabel, valueLabel) => [
          () => {
            const objeto = this.passoGeral[objLabel] || {};
            const val = objeto[valueLabel];
            const msg = this.$t('message.campo_obrigatorio');
            return !!(val) || msg;
          },
        ],
      },
    };
  },
  methods: {
    formatDatePattern,
    delimitaCamposDeProduto() {
      if (this.contratoDefiniuCampoProduto()) {
        return this.camposSemProduto();
      }

      const amostragemCamposProduto = this.amostragemDeCamposDeProduto();
      const menorCampoContrato = this.menorCampoDeProdutoDoContrato();

      const { relacaoCampos } = this.configuracaoAcao;
      return relacaoCampos.filter((c) => {
        if (amostragemCamposProduto.indexOf(c) < 0) {
          return true;
        }

        const campoDaAcao = this.campoDeProdutoDaAcao(c);
        return campoDaAcao && campoDaAcao.indiceRecursao < menorCampoContrato.indiceRecursao;
      });
    },
    campoDeProdutoDaAcao(label) {
      const { mapaEntidades } = this.metadadosParametrizado;
      return mapaEntidades[label];
    },
    menorCampoDeProdutoDoContrato() {
      let menorCampo = { indiceRecursao: Number.MAX_SAFE_INTEGER };
      this.camposLimitadores.forEach((c) => {
        if (menorCampo.indiceRecursao > c.indiceRecursao) {
          menorCampo = c;
        }
      });
      return menorCampo;
    },
    camposSemProduto() {
      const { relacaoCampos } = this.configuracaoAcao;
      const amostragem = this.amostragemDeCamposDeProduto();
      return relacaoCampos
        .filter((c) => c !== 'produto' && amostragem.indexOf(c) < 0);
    },
    amostragemDeCamposDeProduto() {
      const { mapaEntidades } = this.getProdutoMetadado;
      return Object.values(mapaEntidades)
        .map((c) => c.label);
    },
    contratoDefiniuCampoProduto() {
      return this.camposLimitadores
        .filter((c) => c.label === 'produto').length > 0;
    },
    aplicaParametrizacoes() {
      this.metadadosParametrizado = this.configuracaoAcao
        .aplicaParametrizacao(this.getAcaoMetadado);
      this.configuracaoAcao
        .parametrizaCamposOpcionais(this.camposFormulario.padrao);
    },
    buscaClientes(autocomplete) {
      const parametros = {
        autocomplete,
      };

      buscarClientes(parametros, this.$resource)
        .then((res) => {
          this.clientes = res.data;
          if (this.passoGeral.idClienteAcao && this.clientes.length > 0) {
            const clienteSelecionado = this.clientes.find((cliente) => cliente.id === this.passoGeral.idClienteAcao);
            if (clienteSelecionado) {
              this.passoGeral.codCliente = clienteSelecionado.costumerCliente;
            }
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    filtrarCamposFormulario() {
      if (this.passoGeral.indAcaoAgrupadora
        || (this.configuracaoAcao.valorAcaoCalculadoAutomaticamente
        && !this.isDetalheAcaoTemplate)) {
        this.camposFormulario.padrao = this.camposFormulario.padrao.filter((c) => c.labelCampo !== 'valor');
      }
    },
    configuraMetadadoCruzados() {
      const configuracoes = [
        {
          entidade: 'produto',
          metadadosCampo: this.getProdutoMetadado,
        },
      ];
      configuracoes.forEach((cfg) => {
        const campos = this.camposFormulario.padrao;
        const campo = campos.filter((c) => c.labelCampo === cfg.entidade)[0];
        campo.metadadosCampo = cfg.metadadosCampo;
      });
    },
    getObjetoFormatado() {
      const { idConfiguracao, idAcaoTipo } = this.configuracaoAcao;
      const {
        id,
        idClienteAcao,
        descricao,
        numeroContrato,
        notaFiscal,
        status,
        idAcaoAgrupadora,
        indAcaoAgrupadora,
      } = this.passoGeral;

      let codCliente = '';

      if (idClienteAcao && this.clientes.length > 0) {
        const clienteSelecionado = this.clientes.find((cliente) => cliente.id === idClienteAcao);
        if (clienteSelecionado) {
          codCliente = clienteSelecionado.costumerCliente;
        }
      }

      const objetoFormatado = {
        id,
        idAcaoTipo,
        codCliente,
        idConfiguracao,
        idClienteAcao,
        descricao,
        numeroContrato,
        notaFiscal,
        status,
        idAcaoAgrupadora,
        indAcaoAgrupadora,
        ...this.$refs.container.getValoresCamposPadrao(),
      };

      if (!objetoFormatado.valor) {
        objetoFormatado.valor = this.passoGeral.valor;
      }
      if (this.passoGeral.coeficienteValorTotal) {
        objetoFormatado.coeficienteValorTotal = this.passoGeral.coeficienteValorTotal;
      }

      this.formataExtensoes(objetoFormatado);
      this.formataCamposDinamicos(objetoFormatado);

      return objetoFormatado;
    },
    formataExtensoes(objetoFormatado) {
      objetoFormatado.mapaExtensoes = {
        ...this.$refs.container.getValoresDependencias(),
      };
    },
    formataCamposDinamicos(objetoFormatado) {
      const camposDinamicos = this.$refs.container.getValoresCamposDinamicos();
      if (Object.keys(camposDinamicos).length !== 0) {
        objetoFormatado.mapaCamposDinamicos = { ...camposDinamicos };
      }
    },
  },
  mounted() {
    this.buscaClientes();
    this.aplicaParametrizacoes();
    this.configuraMetadadoCruzados();
    this.filtrarCamposFormulario();
    this.parametrosAplicados = true;
  },
};
</script>
